import { useContext } from 'react'

import { ZaiChatContext } from './context'

export function useZaiChat() {
  const context = useContext(ZaiChatContext)

  if (!context) {
    throw new Error('useZaiChat must be used within a ZaiChatProvider')
  }

  return context
}
